module.exports = __webpack_public_path__ + "media/images/products/3-0485d745516562f26b2deca7bbbe3fec.jpg";